import * as authHelper from './helpers'
import axios from 'axios'
import config from './utils'

const axiosInstance = axios.create({
  baseURL: config.url,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: false,
})

// === Intercepteur pour attacher automatiquement le token JWT ===
axiosInstance.interceptors.request.use(
  (config) => {
    const auth = authHelper.getAuth()
    const token = auth?.access_token

    //console.log(token)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => Promise.reject(error),
)

// === Intercepteur pour gérer le refresh token ===
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    // Si on a une erreur 401 et qu'on n’a pas déjà tenté de refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        const auth = authHelper.getAuth()
        const refreshToken = auth?.refresh_token

        if (!refreshToken) {
          throw new Error('No refresh token available')
        }

        // Utilise la même instance Axios, mais sans intercepteurs pour éviter les boucles
        const refreshResponse = await axios.post(
          `${config.url}/users/refresh-token`,
          { refresh_token: refreshToken },
          { headers: { 'Content-Type': 'application/json' } },
        )

        const newAccessToken = refreshResponse.data.access_token

        // Mets à jour l’objet auth dans le local storage
        authHelper.setAuth({
          ...auth,
          access_token: newAccessToken,
        })

        // Mets à jour les headers
        axiosInstance.defaults.headers.Authorization = `Bearer ${newAccessToken}`
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`

        // Rejoue la requête initiale
        return axiosInstance(originalRequest)
      } catch (refreshError) {
        //console.error('Erreur lors du refresh token:', refreshError)
        authHelper.removeAuth()
        //window.location.href = '/login'
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(error)
  },
)

export default axiosInstance
